import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Textarea } from '../input';
import { Error } from '../error';
import { FFSignInButton } from '../signin';
import { useGlobal } from '../../state';

export const AgentCreate = () => {
  const navigate = useNavigate();
  const { fox } = useGlobal();
  const [prompt, setPrompt] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const createAgent = async (event) => {
    event.preventDefault();
    if (!fox || loading) {
      return;
    }

    setError();
    setLoading(true);
    try {
      const out = await fox.call('POST', '/api/agent/create', {
        prompt,
        detach: true,
      });
      navigate(`/agents/run/${out.agentId}`);
    } catch (e) {
      setError(e.message || 'Could not create agent');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 680 }}>
      <h2>Create reusable agent</h2>
      <p style={{ color: '#666' }}>Describe the scrape once, then use the generated parameters to run it again.</p>

      <form onSubmit={createAgent} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <Textarea
          minRows={5}
          placeholder="Scrape product details from https://example.com/products/{{productSlug}}"
          value={prompt}
          onChange={(event) => setPrompt(event.target.value)}
        />
        <Error message={error} />
        {fox ? (
          <Button loading={loading} disabled={loading || !prompt.trim()} style={{ alignSelf: 'flex-start' }}>
            Create agent
          </Button>
        ) : (
          <FFSignInButton style={{ alignSelf: 'flex-start', width: 'auto' }}>Sign in to create agent</FFSignInButton>
        )}
      </form>
    </div>
  );
};
